import {gql} from '@apollo/client';

import {WARE_HOUSE_STORE_DATA} from 'services/basket/constants/queries';

// To Do : remove feature flag
export const BasketProductFragment = ` 
  fragment product on BasketProduct {
    basketProductId
    variantId
    quantity
    status
    size
    originPrice
    discountPrice
    promotedPrice
    promotion {
      productId
      priceBeforePromotion
      promotionIds
      complexPromotionIds
      discountAmount
      unitPriceBeforePromotion
    }
    title
    imageUrls
    deliverySlot {
      sellerName
      deliveryTimeEarliestDate
      deliveryTimeLatestDate
    }
    discountId
    discountAmount
    discountApplied
    outsideOfDeliveryZone
    isBulky
    isWeightedFresh
    isAlcohol
    quantityInUnits
    variants {
      moq
    }
    metafields {
      key
      value
    }
    sku
    installmentType
    weightedFreshPricePerUnit
    isPreOrder
    is1PX
  }
`;

export const DeliverySlotFragment = gql`
  fragment deliverySlot on DeliverySlot {
    id
    date
    from
    to
    sellerName
  }
`;

// To Do : remove feature flag
export const BillingAddressFragment = gql`
  fragment billingAddress on BillingAddressOutputType {
    id
    address1
    address2
    province
    provinceCode
    city
    company
    country
    countryCode
    firstName
    lastName
    phone
    zip
    subdistrict
    latitude
    longitude
    taxId
    branchId
  }
`;

export const ShippingAddressFragment = gql`
  fragment shippingAddress on ShippingAddressOutputType {
    id
    address1
    address2
    province
    provinceCode
    city
    company
    country
    countryCode
    firstName
    lastName
    phone
    zip
    subdistrict
    latitude
    longitude
    deliveryInstructions
  }
`;

export const LoyaltyDetailsFragment = gql`
  fragment loyaltyDetails on LoyaltyDetails {
    referenceId
    redeemPoints
    remainingPoints
    estimatedPointsReceive
    discountCodeId
    priceRuleId
    code
    value
    transactionId
    amount
    data
    maxRedeemablePoints
  }
`;

export const AdvancedPromotionFragment = gql`
  fragment advancedPromotion on AdvancedPromotion {
    simplePromotionId
    complexPromotionId
    description
  }
`;

const SellerDetailsFragment = `
  sellerDetails {
    shopId
    shopName
  }
`;

const currentStore = `currentStore: storeInfo {
    subdistrict: subDistrict
    zipcode: zipCode
    stores {
      name
      shopId
      storeCode
      defaultStore
      omsStoreCode
      shippingFeeOfferId
      sameDay
      ${WARE_HOUSE_STORE_DATA}
    }
  }`;

export const PriceBreakDown_Fragment = gql`
  fragment priceBreakdown on PricesBreakDown {
    shopId
    shopName
    shippingFee
    subtotal
    is3PSeller
    marketplaceType
    dropShippingCarrier
  }
`;

export const PRICES_FRAGMENT = gql`
  ${PriceBreakDown_Fragment}
  fragment prices on Prices {
    totalOriginalPrice
    totalDisplayPricePreVoucher
    totalDisplayPricePostVoucher
    totalFinalPriceToPay
    shippingFee
    minimumBasket
    exactDiscountAmount
    roundedDiscountAmount
    exactVoucherDiscountAmount
    roundedVoucherDiscountAmount
    priceBreakdown {
      ...priceBreakdown
    }
  }
`;

// To Do : remove feature flag
export const CheckoutFragment = gql`
  ${BasketProductFragment}
  ${PRICES_FRAGMENT}
  ${DeliverySlotFragment}
  ${BillingAddressFragment}
  ${ShippingAddressFragment}
  ${LoyaltyDetailsFragment}
  ${AdvancedPromotionFragment}

  fragment checkout on Checkout {
    id
    status
    voucher
    basketId
    customerId
    lineItems {
      ...product
      ${SellerDetailsFragment}
      priceUnit
    }
    prices {
      ...prices,
      isShippingFeeEdited
    }
    discountAmount
    currencyIsoCode
    customerEmail
    orderId
    deliverySlot {
      ...deliverySlot
    }
    billingAddress {
      ...billingAddress
    }
    shippingAddress {
      ...shippingAddress
    }
    paymentURL
    customAttributes {
      key
      value
    }
    dateCreated
    dateModified
    checkoutURL
    loyaltyDetails {
      ...loyaltyDetails
    }
    advancedPromotions {
      ...advancedPromotion
    }
    loyaltyPoints
    zipCode
    subDistrict
    ${currentStore}
    storeCode
    customerInfo {
      firstName
      lastName
      displayName
      email
      mobile
    }
    shippingFeeRule {
      shippingRanges {
        to
        from
        value
      }
      minimumBasket
    }
    freeShippingValue
  }
`;
